module.exports = __webpack_public_path__ + "img/sushil.a4722d9f.png";